import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Komponen Gaji',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Komponen Gaji',
        href: '/adm/komponen-gaji',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_setting-gaji',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'jenis_gaji',
        label: 'Komponen Gaji',
        sortable: true,
      },
      {
        key: 'setting_nominal',
        label: 'Nominal',
      },
      {
        key: 'tipe_setting',
        label: 'Tipe Komponen',
      },
      {
        key: 'group_setting',
        label: 'Group',
      },
      {
        key: 'total_karyawan',
        label: 'Karyawan',
      },
      {
        key: 'nama_pabrik',
        label: 'Pabrik',
      },
      {
        key: 'status_setting',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeKompGaji(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchKompGaji(context, params = null) {
    let result = await ApiGetRequest(`setting-gaji`, params);
    return !result.error ? result.data.object : [];
  },

  async getListKompGaji({ commit, state }) {
    commit('changeKompGaji', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      id_pabrik: data.id_pabrik ? data.id_pabrik : '',
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`setting-gaji`, params);
    commit('changeKompGaji', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailKompGaji({ commit }, payload = null) {
    commit('changeKompGaji', {
      loading: true,
    });

    let result = await ApiGetRequest(`setting-gaji/${payload.id}`);
    commit('changeKompGaji', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadLogoKompGaji({ commit, state }, payload) {
    commit('changeKompGaji', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changeKompGaji', {
      loading: false,
    });

    if (!result.error) {
      commit('changeKompGaji', {
        form: {
          ...data.form,
          foto: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeKompGaji', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`setting-gaji/import`, {
      items: data.import_form || [],
    });

    commit('changeKompGaji', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createKompGaji({ commit, state, dispatch }) {
    commit('changeKompGaji', {
      loading: true,
    });

    let result = await ApiPostRequest(`setting-gaji`, state.data.form);
    commit('changeKompGaji', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateKompGaji({ commit, state, dispatch }, payload = null) {
    commit('changeKompGaji', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `setting-gaji/${payload.id}`,
      state.data.form
    );

    commit('changeKompGaji', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteKompGaji({ commit, dispatch }, payload = null) {
    commit('changeKompGaji', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`setting-gaji/${payload.id}`);
    commit('changeKompGaji', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
